export var topBannerDataTransformer = function topBannerDataTransformer(contentstackData) {
  try {
    // @ts-ignore
    var background_color = contentstackData.background_color,
      copy_color = contentstackData.copy_color,
      long_copy = contentstackData.long_copy,
      short_copy = contentstackData.short_copy;
    var transformedData = {
      bgColor: background_color,
      copyColor: copy_color,
      shortCopy: short_copy.trim()
    };
    var trimmedLongCopy = long_copy.trim();
    if (trimmedLongCopy) {
      transformedData.longCopy = trimmedLongCopy;
    }
    return transformedData;
  } catch (_unused) {
    return null;
  }
};